// extracted by mini-css-extract-plugin
module.exports = {"notification":"CardMenu-modulenotification1oA","divider":"CardMenu-moduledivider12z"};